import { render } from "./country-selector.vue?vue&type=template&id=00eb6df4&ts=true"
import script from "./country-selector.vue?vue&type=script&lang=ts"
export * from "./country-selector.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__